const isDev = process.env.NODE_ENV === 'development';
const isProd = process.env.NODE_ENV === 'production';
const isStage = isProd && window.location.host !== 'www.paypal.com';
const isTest = process.env.NODE_ENV === 'test';

const logDevErrorToConsole = error => {
  const styles = `
    background-color: #b80000;
    color: #fff;
    font: bold 30px;
    line-height: 1.2;
    padding: 20px 15px;
  `;
  const log = `FALLBACK PREVENTED IN DEV MODE -- ERROR: ${error}`;
  console.log(`%c${log}`, styles); // eslint-disable-line no-console
};

export { isDev, isProd, isStage, isTest, logDevErrorToConsole };
